import { useNavigate } from "react-router-dom";
import { Button } from "../components/Button";
import React from "react";
import { authState } from "../recoil";
import { useResetRecoilState, useSetRecoilState } from "recoil";

export const Toolbar: React.FC = () => {
  const setToken = useSetRecoilState(authState);
  const resetAuthState = useResetRecoilState(authState);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("token");
    resetAuthState();
    setToken({
      token: null,
      role: null,
      restaurantId: null,
    });
    navigate("/dashboard/login");
  };
  return (
    <div className="border-b border-slate-200 py-2 flex items-center justify-between">
      <div></div>
      <div>
        <Button lightRed className="text-xs py-2" onClick={handleLogout}>
          Logout
        </Button>
      </div>
    </div>
  );
};
